{
  "memberStatus": {
    "ACTIVE": "Active",
    "BLOCKED": "Blocked"
  },
  "ruleStatus": {
    "ACTIVE": "Active",
    "SCHEDULED": "Scheduled",
    "ENDED": "Ended",
    "OFF": "Off"
  },
  "entryKind": {
    "EARN": "Earned on a sale",
    "EARN_REVERSAL": "Taken back on a return",
    "REDEEM": "Redeemed",
    "REDEEM_RELEASE": "Given back",
    "BONUS": "Welcome bonus",
    "ADJUST": "Adjusted by hand",
    "EXPIRE": "Expired",
    "EXPIRE_REVERSAL": "Expiry undone"
  },
  "overview": {
    "title": "Loyalty points",
    "intro": "Points members earn on what they buy and spend at the till.",
    "links": {
      "members": "Members",
      "transactions": "Transactions",
      "program": "Programme"
    },
    "off": {
      "title": "The programme is switched off",
      "body": "Nobody earns or redeems points while it is off. Balances are kept and can still be adjusted by hand.",
      "open": "Open the programme"
    },
    "figures": {
      "label": "Loyalty figures",
      "outstanding": "Points to spend",
      "worth": "Worth {{value}}",
      "members": "Members",
      "active": "Active: {{n}}",
      "pending": "Pending points",
      "pendingDetail": "Spendable once the return window ends",
      "expiring": "Expiring in 30 days",
      "expiringDetail": "Oldest points expire first",
      "owed": "Points owed back",
      "owedDetail": "Balances below zero after returns"
    },
    "period": {
      "title": "In the period",
      "issued": "Issued",
      "redeemed": "Redeemed",
      "expired": "Expired",
      "reversed": "Taken back",
      "redemptions": "Sales paid with points",
      "newMembers": "New members"
    },
    "chart": {
      "title": "Issued and redeemed by day",
      "label": "Points issued and redeemed each day from {{from}} to {{to}}",
      "issued": "Issued",
      "redeemed": "Redeemed",
      "day": "Day",
      "max": "Highest: {{n}}",
      "point": "{{date}}: {{issued}} issued, {{redeemed}} redeemed",
      "empty": "No points were issued or redeemed in the period."
    },
    "tiers": {
      "title": "Members by tier",
      "none": "No tier",
      "empty": "No members yet."
    },
    "top": {
      "title": "Top members in the period",
      "empty": "Nobody earned points in the period."
    }
  },
  "members": {
    "title": "Members",
    "subtitle": "Customers in the loyalty programme and their points.",
    "enrol": "Enrol customer",
    "searchPlaceholder": "Search name, code or phone…",
    "searchLabel": "Search members",
    "clearSearch": "Clear search",
    "clearFilters": "Clear filters",
    "pendingSmall": "Pending",
    "fields": {
      "customer": "Customer",
      "phone": "Phone",
      "tier": "Tier",
      "available": "Available",
      "earned": "Earned",
      "redeemed": "Redeemed",
      "lastActivity": "Last activity",
      "enrolledAt": "Joined",
      "status": "Status"
    },
    "filters": {
      "status": "Status",
      "allStatuses": "All statuses",
      "balance": "Balance",
      "anyBalance": "Any balance",
      "tier": "Tier",
      "allTiers": "All tiers"
    },
    "balance": {
      "positive": "Points to spend",
      "owing": "Owes points",
      "zero": "No points"
    },
    "empty": {
      "title": "No members yet",
      "body": "Customers join on their first purchase when auto-enrolment is on, or you can enrol them here.",
      "filteredTitle": "No members match",
      "filteredBody": "Try another search or clear the filters."
    }
  },
  "enrol": {
    "title": "Enrol a customer",
    "body": "The customer joins the programme now and starts earning on their next purchase.",
    "customer": "Customer",
    "customerHint": "The walk-in customer cannot join.",
    "chooseCustomer": "Choose the customer to enrol",
    "confirm": "Enrol",
    "openMember": "Open their member page",
    "toast": "{{name}} joined the programme"
  },
  "member": {
    "since": "Member since {{date}}",
    "lastActivity": "Last activity {{date}}",
    "openCustomer": "Customer page",
    "blockedOn": "Blocked on {{date}}",
    "blockedBody": "A blocked member neither earns nor redeems points. Their balance is kept.",
    "blockedReason": "Reason: {{reason}}",
    "figures": "Points",
    "available": "Available",
    "owes": "Owes points back",
    "pending": "Pending",
    "pendingDetail": "Spendable after the return window",
    "expiringSoon": "Expiring soon",
    "expiringSoonDetail": "Within 30 days",
    "earned": "Earned",
    "redeemed": "Redeemed",
    "expired": "Expired",
    "details": "Membership",
    "statement": "Statement",
    "statementEmpty": "No points have moved yet.",
    "actions": {
      "adjust": "Adjust points",
      "block": "Block",
      "unblock": "Unblock"
    },
    "fields": {
      "customerCode": "Customer code",
      "enrolledAt": "Joined",
      "lastActivity": "Last activity",
      "blockedReason": "Why blocked"
    },
    "tier": {
      "title": "Tier",
      "qualifying": "Earned in the last 12 months",
      "current": "Current tier: {{tier}}",
      "noneYet": "No tier reached yet.",
      "progress": "Progress to the next tier",
      "toNext_one": "{{n}} more point to reach {{tier}}",
      "toNext_other": "{{n}} more points to reach {{tier}}",
      "top": "The highest tier.",
      "window": "Tiers count points earned on purchases in the last 12 months."
    }
  },
  "adjust": {
    "title": "Adjust points",
    "body": "Points {{name}} can spend now: {{n}}",
    "direction": "Add or take away",
    "add": "Add points",
    "deduct": "Take away points",
    "points": "Points",
    "reason": "Reason",
    "reasonHint": "Kept on the statement and in the audit log.",
    "expiresOn": "Expires on",
    "expiresOnHint": "Leave empty to follow the programme’s expiry.",
    "confirmAdd": "Add points",
    "confirmDeduct": "Take away points",
    "toastAdded_one": "{{n}} point added for {{name}}",
    "toastAdded_other": "{{n}} points added for {{name}}",
    "toastDeducted_one": "{{n}} point taken away from {{name}}",
    "toastDeducted_other": "{{n}} points taken away from {{name}}"
  },
  "block": {
    "title": "Block {{name}}?",
    "body": "They stop earning and redeeming points until unblocked. Their balance is kept.",
    "reason": "Reason",
    "confirm": "Block member",
    "toast": "{{name}} is blocked"
  },
  "unblock": {
    "title": "Unblock {{name}}?",
    "body": "They earn and redeem points again from now on.",
    "confirm": "Unblock member",
    "toast": "{{name}} is active again"
  },
  "entries": {
    "kindFilter": "Kind",
    "allKinds": "All kinds",
    "draft": "Draft",
    "system": "System",
    "availableOn": "Available {{date}}",
    "expiresOn": "Expires {{date}}",
    "fields": {
      "date": "Date",
      "member": "Member",
      "kind": "Kind",
      "points": "Points",
      "value": "Value",
      "document": "Document",
      "dates": "Available / expires",
      "reason": "Reason",
      "by": "By"
    },
    "empty": {
      "filteredTitle": "Nothing matches",
      "filteredBody": "Try another search or clear the filters."
    }
  },
  "transactions": {
    "title": "Points transactions",
    "subtitle": "Every movement of points: earned, redeemed, taken back, given back, adjusted and expired.",
    "searchPlaceholder": "Search invoice, credit note, reason or customer…",
    "searchLabel": "Search transactions",
    "empty": {
      "title": "No points have moved yet",
      "body": "Members earn points when their sales invoices are posted or paid."
    }
  },
  "program": {
    "title": "Loyalty programme",
    "subtitle": "How members earn and redeem points. Not saved yet: these are the starting terms.",
    "lastChanged": "Last changed {{date}}",
    "lastChangedBy": "Last changed {{date}} by {{name}}",
    "readOnlyTitle": "Read only",
    "readOnlyBody": "Changing the programme needs the permission to manage loyalty.",
    "loadFailed": "The programme could not be loaded",
    "notSaved": "The programme was not saved",
    "save": "Save programme",
    "discard": "Discard changes",
    "saveHint": "{{shortcut}} saves",
    "activeOn": "On: members earn and redeem points",
    "activeOff": "Off: nobody earns or redeems",
    "autoEnrollLabel": "Enrol customers on their first purchase",
    "earnIncludesTaxLabel": "Earn on the VAT too",
    "combineLabel": "Allow points on sales with a discount",
    "toast": {
      "saved": "Programme saved"
    },
    "conflict": {
      "title": "Someone else changed the programme",
      "body": "Reload to see their changes, then make yours again.",
      "reload": "Reload"
    },
    "sections": {
      "program": "Programme",
      "earning": "Earning",
      "earningHint": "Points are credited on posted sales invoices.",
      "redeeming": "Redeeming",
      "redeemingHint": "Members spend points at the till as a discount before VAT."
    },
    "fields": {
      "active": "Status",
      "name": "Name",
      "nameAr": "Name in Arabic",
      "autoEnroll": "Auto-enrolment",
      "welcomePoints": "Welcome points",
      "earnRate": "Points per OMR 1.000",
      "earnOn": "Credit the points",
      "earnIncludesTax": "VAT",
      "rounding": "Rounding",
      "availableAfterDays": "Spendable after",
      "expiryMonths": "Expire after",
      "redeemRate": "Redeem rate",
      "minRedeemPoints": "Least points per redemption",
      "maxRedeemPercent": "Most of a sale paid with points",
      "minRedeemSale": "Smallest sale for redeeming",
      "combineWithDiscounts": "Sale discounts"
    },
    "hints": {
      "active": "Off keeps every balance; nobody earns or redeems until it is on again.",
      "autoEnroll": "Off: only customers enrolled by hand earn points.",
      "welcomePoints": "Given once, when a customer joins. 0 gives none.",
      "earnRate": "On the amount after discounts, before VAT unless VAT is included. 0 pauses earning.",
      "rounding": "Applied once per invoice.",
      "availableAfterDays": "A return window: 0 makes points spendable at once.",
      "expiryMonths": "Counted from when the points become spendable. 0: they never expire.",
      "minRedeemPoints": "A member must hold at least this many to redeem.",
      "maxRedeemPercent": "Of the sale after discounts, before VAT.",
      "minRedeemSale": "After discounts, before VAT.",
      "combineWithDiscounts": "Off: no points can be redeemed on a sale that already has a discount on the whole sale."
    },
    "units": {
      "points": "points",
      "days": "days",
      "months": "months"
    },
    "earnOn": {
      "POSTED": "When the invoice is posted",
      "POSTEDHint": "Members see their points as soon as the sale is invoiced.",
      "PAID": "When it is paid in full",
      "PAIDHint": "Credit sales earn only once the customer has paid."
    },
    "rounding": {
      "FLOOR": "Round down",
      "NEAREST": "Round to the nearest point",
      "CEIL": "Round up"
    },
    "redeemRateOption_one": "{{n}} point = {{value}}",
    "redeemRateOption_other": "{{n}} points = {{value}} · 1 point = {{point}}",
    "example": {
      "title": "Worked example",
      "earn_one": "A sale of {{net}} before VAT earns {{n}} point.",
      "earn_other": "A sale of {{net}} before VAT earns {{n}} points.",
      "earnWithTax_one": "A sale of {{net}} before VAT ({{gross}} with 5% VAT) earns {{n}} point.",
      "earnWithTax_other": "A sale of {{net}} before VAT ({{gross}} with 5% VAT) earns {{n}} points.",
      "redeem": "{{n}} points take {{value}} off a sale (1 point = {{point}}).",
      "incomplete": "Fill in the earn rate and the redeem rate to see an example."
    }
  },
  "tiers": {
    "title": "Tiers",
    "hint": "Reached by points earned on purchases in the last 12 months; each multiplies what its members earn.",
    "add": "Add tier",
    "edit": "Edit",
    "delete": "Delete",
    "actionsFor": "Actions for {{name}}",
    "newTitle": "New tier",
    "editTitle": "Edit {{name}}",
    "dialogBody": "Members move into the tier as soon as their points of the last 12 months reach it.",
    "save": "Save tier",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Its members move to the tier below, or to no tier.",
    "deleteConfirm": "Delete tier",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "minPoints": "Points to reach",
      "multiplier": "Earning multiplier",
      "members": "Members"
    },
    "hints": {
      "minPoints": "Earned on purchases in the last 12 months.",
      "multiplier": "1 to 10: 1.5 earns half as much again."
    },
    "empty": {
      "title": "No tiers",
      "body": "Without tiers every member earns at the programme rate."
    },
    "toast": {
      "created": "{{name}} added",
      "updated": "{{name}} saved",
      "deleted": "{{name}} deleted"
    }
  },
  "rules": {
    "title": "Bonus rules",
    "hint": "Earn more, a fixed number, or nothing on some items, always or only between two dates. The most specific rule wins.",
    "add": "Add rule",
    "edit": "Edit",
    "delete": "Delete",
    "actionsFor": "Actions for {{name}}",
    "newTitle": "New bonus rule",
    "editTitle": "Edit {{name}}",
    "dialogBody": "A variant’s rule beats its product’s, a product’s beats its category’s, and a category’s beats one for everything.",
    "namePlaceholder": "e.g. Double points on coffee",
    "save": "Save rule",
    "deleteTitle": "Delete {{name}}?",
    "deleteBody": "Sales from now on earn without it. Points already earned stay.",
    "deleteConfirm": "Delete rule",
    "allHint": "Every item sold.",
    "noAccess": "Choosing items needs permission to look up products.",
    "searchCategories": "Search categories…",
    "noCategories": "No categories found",
    "fields": {
      "name": "Name",
      "appliesTo": "Applies to",
      "earns": "Earns",
      "mode": "Earning",
      "multiplier": "Multiplier",
      "fixedPoints": "Points per unit",
      "dates": "Dates",
      "startsOn": "From",
      "endsOn": "Until",
      "status": "Status",
      "active": "Rule is on"
    },
    "hints": {
      "multiplier": "× the programme rate: 2 earns double, 0 earns nothing.",
      "fixedPoints": "For each unit sold, whatever the price.",
      "none": "Sales of these items earn no points.",
      "dates": "Leave both empty for a standing rule; a promotion beats a standing rule on the same items."
    },
    "empty": {
      "title": "No bonus rules",
      "body": "Every item earns at the programme rate (times the member’s tier)."
    },
    "target": {
      "ALL": "Everything",
      "CATEGORY": "A category",
      "PRODUCT": "A product",
      "VARIANT": "A variant"
    },
    "targetNamed": {
      "ALL": "Everything",
      "CATEGORY": "Category: {{name}}",
      "PRODUCT": "Product: {{name}}",
      "VARIANT": "Variant: {{name}}"
    },
    "pick": {
      "ALL": "Items",
      "CATEGORY": "Category",
      "PRODUCT": "Product",
      "VARIANT": "Variant"
    },
    "pickPlaceholder": {
      "ALL": "Everything",
      "CATEGORY": "Choose a category",
      "PRODUCT": "Search a product",
      "VARIANT": "Search a variant by name, SKU or barcode"
    },
    "mode": {
      "MULTIPLIER": "Multiply the rate",
      "FIXED": "Fixed points per unit",
      "NONE": "No points"
    },
    "modeText": {
      "MULTIPLIER": "× {{multiplier}}",
      "FIXED_one": "{{n}} point per unit",
      "FIXED_other": "{{n}} points per unit",
      "NONE": "No points"
    },
    "dates": {
      "always": "Always",
      "between": "{{from}} – {{to}}",
      "from": "From {{from}}",
      "until": "Until {{to}}",
      "noStart": "No start",
      "noEnd": "No end"
    },
    "toast": {
      "created": "{{name}} added",
      "updated": "{{name}} saved",
      "deleted": "{{name}} deleted"
    }
  },
  "customerTab": {
    "title": "Loyalty",
    "notMember": "Not a member yet",
    "notMemberBody": "Enrol the customer to let them earn points on their purchases.",
    "autoEnrolBody": "They join on their first purchase, or you can enrol them now.",
    "enrol": "Enrol",
    "openMember": "Open member page"
  },
  "leave": {
    "title": "Leave without saving?",
    "body": "Your changes to the programme will be lost.",
    "confirm": "Leave",
    "cancel": "Stay"
  },
  "errors": {
    "LOYALTY_NOT_ELIGIBLE": "This customer cannot join the programme: the walk-in customer never earns points, and an archived customer must be restored first.",
    "LOYALTY_ALREADY_MEMBER": "This customer is already a member.",
    "LOYALTY_INSUFFICIENT_POINTS": "That would take the member below zero points: take away fewer.",
    "insufficientCount_one": "The member has only {{n}} point to spend: take away fewer.",
    "insufficientCount_other": "The member has only {{n}} points to spend: take away fewer.",
    "LOYALTY_TIER_DUPLICATE": "Another tier already has this name or this number of points."
  },
  "validation": {
    "wholeNumber": "Use a whole number",
    "twoDecimals": "Use a number with up to 2 decimals",
    "earnRateRange": "Use 0 to 1000 points",
    "nameProgram": "Name the programme",
    "listedRate": "Choose one of the listed rates",
    "percentRange": "Use 0 to 100 percent",
    "nameTier": "Name the tier",
    "atLeastOnePoint": "Use at least 1 point",
    "multiplierRange": "Use 1 to 10",
    "nameRule": "Name the rule",
    "ruleMultiplierRange": "Use 0 to 100",
    "allNoItem": "A rule for everything names no item",
    "chooseTarget": "Choose what the rule covers",
    "enterMultiplier": "Enter the multiplier",
    "enterFixedPoints": "Enter the points per unit",
    "endBeforeStart": "The end is before the start",
    "enterPoints": "Enter points to add or take away",
    "onlyAddedExpire": "Only added points expire"
  }
}
